import { render } from "./HotPointCard.vue?vue&type=template&id=63e6d8ee&scoped=true"
import script from "./HotPointCard.vue?vue&type=script&lang=js"
export * from "./HotPointCard.vue?vue&type=script&lang=js"

import "./HotPointCard.vue?vue&type=style&index=0&id=63e6d8ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e6d8ee"]])

export default __exports__